import AnimationComponent from '../../Component/Animation';
import ElementComponent from '../../Component/UI/Element';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Point from '../../Utility/Point';
import { StartAnimation, StartAnimationClip, StopAnimation } from '../Animation/AnimationHelper';
import { PlaySound } from '../Audio/AudioHelper';
import TransformComponent from '../../Component/Transform';
import SpriteComponent from '../../Component/Render/Sprite';
import { ButtonPress, ButtonRelease } from 'System/Animation/Clip';

export function applyDefaultButtonAnimation(
    gameObject: GameObject,
    audioClipName?: string,
    shadow: boolean = true,
    animationsAdditive = false
): void {
    const component = gameObject.hasComponent(ElementComponent)
        ? gameObject.getComponent(ElementComponent)
        : gameObject.getComponent(TransformComponent);
    if (!gameObject.hasComponent(AnimationComponent)) {
        gameObject.addComponent(AnimationComponent);
    }

    const scale: Point = new Point(1, 1);
    if (component.scale) {
        scale.set(component.scale.x, component.scale.y);
    }
    const onDown = () => {
        StartAnimationClip(new ButtonPress(gameObject, { scale, forceNoShadow: !shadow }, animationsAdditive));
        if (audioClipName) {
            PlaySound(audioClipName);
        } else {
            PlaySound('button-press');
        }
    };

    const onUp = () => {
        StartAnimationClip(new ButtonRelease(gameObject, { scale, forceNoShadow: !shadow }, animationsAdditive));
    };

    const onOut = () => {
        StartAnimationClip(new ButtonRelease(gameObject, { scale, forceNoShadow: !shadow }, animationsAdditive));
    };

    gameObject.on(GameObjectEvent.POINTER_DOWN, onDown);
    gameObject.on(GameObjectEvent.POINTER_UP, onUp);
    gameObject.on(GameObjectEvent.POINTER_OUT, onOut);
    gameObject.once(GameObjectEvent.DESTROYED, () => {
        gameObject.off(GameObjectEvent.POINTER_DOWN, onDown);
        gameObject.off(GameObjectEvent.POINTER_UP, onUp);
        gameObject.off(GameObjectEvent.POINTER_OUT, onOut);
    });
}

export function applyBounceButtonAnimation(
    gameObject: GameObject,
    audioClipName: string,
    idleAnimationClip: string = 'ButtonBounceLoop'
): void {
    const element = gameObject.getComponent(ElementComponent);
    if (!gameObject.hasComponent(AnimationComponent)) {
        gameObject.addComponent(AnimationComponent);
    }

    const animation = gameObject.getComponent(AnimationComponent);

    const scale: Point = new Point(1, 1);
    if (element.scale) {
        scale.set(element.scale.x, element.scale.y);
    }

    StartAnimation(gameObject, idleAnimationClip, { scale: scale });

    gameObject.on(GameObjectEvent.POINTER_DOWN, () => {
        StartAnimation(gameObject, 'ButtonPress', { scale: scale });
        PlaySound(audioClipName);
    });
    gameObject.on(GameObjectEvent.POINTER_UP, () => {
        StartAnimation(gameObject, idleAnimationClip, { scale: scale });
    });
    gameObject.on(GameObjectEvent.POINTER_OUT, () => {
        if (animation.clipName !== idleAnimationClip) {
            StartAnimation(gameObject, idleAnimationClip, {
                scale: scale,
            });
        }
    });
}

export function removeBounceButtonAnimation(gameObject: GameObject): void {
    StopAnimation(gameObject);
    gameObject.off(GameObjectEvent.POINTER_DOWN);
    gameObject.off(GameObjectEvent.POINTER_UP);
    gameObject.off(GameObjectEvent.POINTER_OUT);
}

export function applyFrameButtonAnimation(props: { button: GameObject; idleAsset: string; clickAsset: string }) {
    const { button, idleAsset, clickAsset } = props;
    button.addComponent(SpriteComponent);
    const spriteComponent = button.getComponent(SpriteComponent);

    const onRelease = () => {
        spriteComponent.texture = idleAsset;
    };

    button.on(GameObjectEvent.POINTER_DOWN, () => {
        spriteComponent.texture = clickAsset;
    });
    button.on(GameObjectEvent.POINTER_UP, onRelease);
    button.on(GameObjectEvent.POINTER_OUT, onRelease);
}
